import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'angular-boss-pdf',
  templateUrl: './angular-boss-pdf.component.html',
  styleUrls: ['./angular-boss-pdf.component.css']
})
export class AngularBossPdfComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
